import { SET_EVENTS } from ":mutations";
import { REQUEST_EVENTS } from ":actions";

import http from ":http";

const state = {
  events: {
    content: []
  }
};

const mutations = {
  [SET_EVENTS](state, { events }) {
    state.events = events;
  }
};

const actions = {
  [REQUEST_EVENTS](
    { state, commit },
    {
      page,
      size,
      domain,
      action,
      resourceId,
      userAgent,
      address,
      from,
      to,
      sort
    }
  ) {
    return http
      .get("/statistics", {
        params: {
          domain,
          action,
          resourceId,
          userAgent,
          address,
          from,
          to,
          size,
          sort,
          page: page ? page - 1 : state.events.page
        }
      })
      .then(response =>
        commit(SET_EVENTS, {
          events: { ...response.data, page: response.data.number + 1 }
        })
      );
  }
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters
};
